import { pxToEm, themeV2 } from '@insticator/insticator-ui'

/* ++++++++++ --------------- USER FORM : STYLES --------------- ++++++++++ */
export default {
  '@global': {
    '.name-emailexistinlinemsg': {
      border: 'none !important',
      boxShadow: 'none !important',
      padding: `${pxToEm(24)} ${pxToEm(20)}`,
      textAlign: 'justify',
      '& p': {
        padding: `0 ${pxToEm(16)}`
      }
    },
    '.name-emailexistctas': {
      '& .button': {
        margin: `${pxToEm(4)} ${pxToEm(8)}`
      }
    }
  },
  userform: {
    position: 'relative',
    zIndex: 4,
    '& label': {
      color: themeV2.color.primary.main
    },
    '& .sectioncard': {
      padding: `${pxToEm(32)} !important`,
      border: 0
    },
    '& .button': {
      height: pxToEm(40)
    },   
    '& .name-userdetailsform': {
      '& .name-formcontainer': {
        maxWidth: pxToEm(800),
        '& .name-details': {
          marginBottom: pxToEm(16),
          '& .griditem': {
            maxWidth: pxToEm(240),
            marginBottom: pxToEm(16)
          }
        },
        '& .name-permissions': {
          justifyContent: 'space-between',
          marginBottom: pxToEm(32),
          '& .griditem': {
            marginBottom: pxToEm(12)
          }
        }
      },
      '& .name-commentingaccount': {
        padding: `${pxToEm(16)} ${pxToEm(48)}`,
        paddingTop: pxToEm(8),
        '& .name-sitesdropdown': {
          height: pxToEm(48),
          '& .dropdowncontainer': { height: pxToEm(48)},
          '& .name': {display: 'none'}
        }
      }
    },
    '&.newuserform': {
      boxShadow: 'none !important',
      borderRadius: 0,
      '& .innerWrap': {
        padding: `0 !important`,
        margin: 0,
        borderRadius: 0,
        background: '#fff'
      },
      '& .sectioncard': {
        padding: `${pxToEm(30)} !important`, 
        marginBottom: 0,
        border: `${pxToEm(10)} solid ${themeV2.color.background.light.gray}`,
        '&:last-child': {
          borderTop: 0
        }
      },
      '& .name-permissions': {
        marginBottom: `0 !important`
      },
      '& .newusertitle': {
        margin: `${pxToEm(8)} 0 ${pxToEm(24)}`
      }
    },
    // custom error message for email field
    '& .emailfield': {
      '& .errormessage': {
        display: 'none !important'
      }
    },
    '& .errormessage': {
      opacity: '0',
      display: 'block',
      color: themeV2.color.error.main,
      fontSize: pxToEm(14),
      marginTop: pxToEm(5),
      // animate in 
      animationName: 'fadeInDown',
      animationDelay: '0s',
      animationDuration: '.1s',
      animationFillMode: 'forwards'
    },
    '& .name-siteplaceholder': {
      marginBottom: `0 !important`,
      '& h4': {
        color: themeV2.color.primary.main
      }
    },
    '& .badgeimg': {
      width: pxToEm(40),
      height: pxToEm(40),
      borderRadius: pxToEm(8),
      marginRight: pxToEm(8)
    },
    '& .name-badgeimggrid': {
      display: 'flex',
      alignItems: 'center'
    },
    '& .name-rolesdropdowngrid': {
      marginRight: `0 !important`
    },
    '& .commentinguserroles': {
      '&.error-true': {
        '& > .placeholder': {
          borderColor: themeV2.color.error.main
        }
      }
    },
    '& .name-sitesdropdown': {
      '&.error-true': {
        '& .dropdownindicator': {
          borderColor: themeV2.color.error.main
        }
      }
    },
    '& .name-disable-commenting-account-message': {
      marginBottom: pxToEm(16)
    }
  }
}; 